exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".folded:not(.folded-open) :host .nav-link > span {\n  opacity: 0;\n  -webkit-transition: opacity 200ms ease;\n  transition: opacity 200ms ease; }\n\n:host .nav-link .collapse-arrow {\n  -webkit-transition: opacity .25s ease-in-out .1s, -webkit-transform .3s ease-in-out;\n  transition: opacity .25s ease-in-out .1s, -webkit-transform .3s ease-in-out;\n  transition: transform .3s ease-in-out, opacity .25s ease-in-out .1s;\n  transition: transform .3s ease-in-out, opacity .25s ease-in-out .1s, -webkit-transform .3s ease-in-out;\n  -webkit-transform: rotate(0);\n          transform: rotate(0); }\n\n:host > .children {\n  overflow: hidden; }\n\n:host.open > .nav-link .collapse-arrow {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/core/components/navigation/vertical/nav-collapse/nav-vertical-collapse.component.scss
// module id = ../../../../../src/app/core/components/navigation/vertical/nav-collapse/nav-vertical-collapse.component.scss
// module chunks = main